import axios from 'axios';
import { ONE, ZERO } from '@/constants/common';

import { PluginMock } from '@/components/admin/plugins/pluginMock';

export const validatePluginContent = async (
  url: string,
): Promise<{ name: string; version: string }> => {
  try {
    const response = await axios.get(url);

    let pluginScript = response.data;

    pluginScript += `//# sourceURL=${url}`;

    PluginMock.init();
    /* eslint-disable no-new-func */
    const loadPlugin = new Function(pluginScript);

    await loadPlugin();

    const pluginData = PluginMock.getPluginData(url);
    if (!pluginData) {
      throw new Error('Plugin data not found');
    }

    return pluginData;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    throw new Error(error instanceof Error ? error.message : 'Failed to validate plugin content');
  }
};

export const getIdFromIdentifiersOrgUri = (uri: string): string | null => {
  const lastIndex = Math.max(uri.lastIndexOf('/'), uri.lastIndexOf(':'));
  return lastIndex > ZERO ? uri.substring(lastIndex + ONE) : null;
};
